import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUserRole } from '../../contexts/UserRoleContext';

interface AccessDeniedPageProps {
  /** The page or feature the user tried to access. Surfaced in the help text
   *  so the user understands which permission was missing. */
  page?: string;
}

/**
 * AccessDeniedPage — rendered when RoleGuard refuses a route because the
 * current user's role doesn't meet `requiredRole`. Wiz-parity: deny is loud
 * (clear messaging + role shown) instead of silent.
 */
export default function AccessDeniedPage({ page = 'this page' }: AccessDeniedPageProps) {
  const { role } = useUserRole();
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center min-h-[70vh] px-4">
      <div className="text-center max-w-xl">
        <div className="flex justify-center mb-6">
          <ShieldOff className="w-16 h-16 text-amber-400" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-3">Access denied</h1>
        <p className="text-gray-400 mb-2">
          You don't have permission to access {page}.
        </p>
        <p className="text-gray-500 text-sm mb-8">
          Your current role is <span className="font-mono text-amber-300">{role}</span>.
          Ask an administrator to grant the required role.
        </p>
        <button
          onClick={() => navigate('/overview')}
          className="px-6 py-3 bg-[#325FE8] hover:bg-[#2850d0] text-white font-medium rounded-lg transition-colors"
        >
          Back to Overview
        </button>
      </div>
    </div>
  );
}
